module.exports = __webpack_public_path__ + "img/cropped-owl@4x-180x180.8b0f5c67.png";